/* Header behavior: burger drawer + predictive search (Shopify Predictive
   Search API + Section Rendering API). Progressive enhancement — the search
   form submits to /search without JS, and nav links are plain anchors. */
(function () {
  'use strict';

  function initSearch(header, wrap) {
    var input = wrap.querySelector('[data-search-input]');
    var results = wrap.querySelector('[data-search-results]');
    var url = header.getAttribute('data-predictive-url');
    if (!input || !results || !url) return;

    var timer = null;
    var seq = 0;

    function close() {
      results.hidden = true;
      results.innerHTML = '';
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) {
        close();
        return;
      }
      timer = setTimeout(function () {
        var current = ++seq;
        fetch(
          url +
            '?q=' + encodeURIComponent(q) +
            '&resources[type]=product,article,page' +
            '&resources[limit]=4&resources[limit_scope]=each' +
            '&section_id=predictive-search'
        )
          .then(function (r) { return r.text(); })
          .then(function (text) {
            if (current !== seq) return; // a newer query is in flight
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var inner = doc.querySelector('#Predictive-Search-Results');
            if (inner && inner.innerHTML.trim() !== '') {
              results.innerHTML = inner.innerHTML;
              results.hidden = false;
            } else {
              close();
            }
          })
          .catch(function () {});
      }, 250);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        close();
        input.blur();
      }
    });

    wrap.closeSearch = close;
  }

  function initHeader(header) {
    var toggle = header.querySelector('[data-menu-toggle]');
    var drawer = header.querySelector('[data-menu-drawer]');
    var searches = header.querySelectorAll('[data-search]');

    if (toggle && drawer) {
      toggle.addEventListener('click', function () {
        var opening = drawer.hidden;
        drawer.hidden = !opening;
        toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
        toggle.textContent = opening ? '×' : '☰';
      });
    }

    searches.forEach(function (wrap) {
      initSearch(header, wrap);
    });

    // Close open search dropdowns on any click outside their wrapper (v6 behavior).
    document.addEventListener('click', function (e) {
      searches.forEach(function (wrap) {
        if (!wrap.contains(e.target) && typeof wrap.closeSearch === 'function') {
          wrap.closeSearch();
        }
      });
    });
  }

  document.querySelectorAll('[data-header]').forEach(initHeader);
})();
